"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var videoplayer_device_1 = require("@svt/videoplayer-device");

var withTheme_1 = require("../utils/withTheme");

var EnterFullscreenIcon_1 = __importDefault(require("./icons/EnterFullscreenIcon"));

var ExitFullscreenIcon_1 = __importDefault(require("./icons/ExitFullscreenIcon"));

var handleClick = function handleClick(e, props) {
  e.preventDefault();
  videoplayer_device_1.toggleFullscreen(props.getFullscreenElement());
};

var handleTouchEnd = function handleTouchEnd(e, props) {
  videoplayer_device_1.toggleFullscreen(props.getFullscreenElement());
};

var handleMouseDown = function handleMouseDown(e) {
  // Prevent focus on mouse down
  e.preventDefault();
};

var FullscreenButton = function FullscreenButton(props, _a) {
  var theme = _a.theme;
  var activeFullscreenElement = videoplayer_device_1.getActiveFullscreenElement();
  return withTheme_1.withTheme(theme, 'fullscreen-button')(React.createElement("button", {
    onClick: function onClick(e) {
      return handleClick(e, props);
    },
    onMouseDown: handleMouseDown,
    onTouchEnd: function onTouchEnd(e) {
      return handleTouchEnd(e, props);
    },
    title: "Fullsk\xE4rm"
  }, activeFullscreenElement ? React.createElement(ExitFullscreenIcon_1["default"], null) : React.createElement(EnterFullscreenIcon_1["default"], null)));
};

FullscreenButton.contextTypes = {
  theme: PropTypes.object
};
exports["default"] = FullscreenButton;